const HandleDateTimeLeft = (date, expiryText) => {
  const seconds = Math.floor((new Date(date) - new Date()) / 1000);
  let interval = seconds / 31536000;
  // Check if past date
  if (seconds < 0) {
    return expiryText ?? "Expired";
  }
  // CHeck how many years left from now to future date
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return (
        Math.floor(interval) +
        " years" + // check if more than 1 year left and if so, add the following "months  left"
        (Math.floor((seconds % 31536000) / 2592000) > 1 // check if more than 1 month left and if so, add the following "months  left"
          ? ", " + Math.floor((seconds % 31536000) / 2592000) + " months left"
          : Math.floor((seconds % 31536000) / 2592000) > 0 // check if more than 0 month left and if so, add the following "months  left"
          ? ", " + Math.floor((seconds % 31536000) / 2592000) + " month left" // check if more than 1 month left and if so, add the following "days  left"
          : // : Math.floor((seconds % 31536000) / 86400) > 1 // check if more than 1 day left and if so, add the following "days  left"
            // ? ", " + Math.floor((seconds % 31536000) / 86400) + " days left"
            // : Math.floor((seconds % 31536000) / 86400) > 0 // check if more than 0 day left and if so, add the following "days  left"
            // ? ", " + Math.floor((seconds % 31536000) / 86400) + " day left" // check if more than 1 day left and if so, add the following "hours  left"
            // : Math.floor((seconds % 31536000) / 3600) > 1 // check if more than 1 hour left and if so, add the following "hours  left"
            // ? ", " + Math.floor((seconds % 31536000) / 3600) + " hours left"
            // : Math.floor((seconds % 31536000) / 3600) > 0 // check if more than 0 hour left and if so, add the following "hours  left"
            // ? ", " + Math.floor((seconds % 31536000) / 3600) + " hour left" // check if more than 1 hour left and if so, add the following "minutes  left"
            // : Math.floor((seconds % 31536000) / 60) > 1 // check if more than 1 minute left and if so, add the following "minutes  left"
            // ? ", " + Math.floor((seconds % 31536000) / 60) + " minutes left"
            // : Math.floor((seconds % 31536000) / 60) > 0 // check if more than 0 minute left and if so, add the following "minutes  left"
            // ? ", " + Math.floor((seconds % 31536000) / 60) + " minute left" // check if more than 1 minute left and if so, add the following "seconds  left"
            // : Math.floor((seconds % 31536000) % 60) > 1 // check if more than 1 second left and if so, add the following "seconds  left"
            // ? ", " + Math.floor((seconds % 31536000) % 60) + " seconds left"
            // : Math.floor((seconds % 31536000) % 60) > 0 // check if more than 0 second left and if so, add the following "seconds  left"
            // ? ", " + Math.floor((seconds % 31536000) % 60) + " second left"
            "left")
      );
    } else {
      return (
        Math.floor(interval) +
        " year" + // check if more than 1 year left and if so, add the following "months  left"
        (Math.floor((seconds % 31536000) / 2592000) > 1 // check if more than 1 month left and if so, add the following "months  left"
          ? ", " + Math.floor((seconds % 31536000) / 2592000) + " months left"
          : Math.floor((seconds % 31536000) / 2592000) > 0 // check if more than 0 month left and if so, add the following "months  left"
          ? ", " + Math.floor((seconds % 31536000) / 2592000) + " month left" // check if more than 1 month left and if so, add the following "days  left"
          : " left")
      );
    }
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " months left";
    } else {
      return Math.floor(interval) + " month left";
    }
  }
  interval = seconds / 86400;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " days left";
    } else {
      return Math.floor(interval) + " day left";
    }
  }
  interval = seconds / 3600;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " hours left";
    } else {
      return Math.floor(interval) + " hour left";
    }
  }
  interval = seconds / 60;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " minutes left";
    } else {
      return Math.floor(interval) + " minute left";
    }
  }
  // Check if plural
  if (Math.floor(seconds) > 1) {
    return Math.floor(seconds) + " seconds left";
  } else {
    return Math.floor(seconds) + " second left";
  }
  //
};

export default HandleDateTimeLeft;
